import React, { Fragment } from "react";
import {
  CircularProgress,
  Grid,
  Paper,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import withStyles from "@mui/styles/withStyles";
import CommonStyles from "../../assets/jss/reports/commonStyles";
import icons from "../../components/icons";
import {
  Bar,
  BarChart,
  CartesianGrid,
  ComposedChart,
  Legend,
  Line,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { Card } from "@mui/material/index";
import PerformanceGraphStyles from "../../assets/jss/reports/reportsStyles";
import * as _ from "lodash";
import {
  graphSpacing,
  IsLoading,
  yAxisFontSize,
  yAxisFormatter,
} from "./performanceGraph";

function ImpressionGraph(props) {
  const {
    classes,
    data,
    kpiType,
    isLoading,
    theme,
    tabValue,
    handleChange,
    handleReportSent,
    handleRefs,
    handleDownloadReport,
  } = props;
  // const modifiedData = (_.isEmpty(data) || (data && data.data.length > 0)) ? data.data.map((obj)=>({...obj,dateRange:"week["+dateRange +"]"})) : [];
  let metric = "revenue";
  console.log("KPI type is metric: ", kpiType);
  console.log("Impression share Performance data is: ", data);
  if (kpiType != null && kpiType != undefined) {
    if (kpiType == "RC" || kpiType == "CR") {
      metric = "revenue";
    } else if (kpiType == "CPL") {
      metric = "leads";
    } else {
      metric = "orders";
    }
  }

  const CommaFormattedNumber = (number) => {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  return (
    <Paper className={classes.paper}>
      <Grid
        container
        justifyContent={"space-between"}
        style={{ background: "#ffffff" }}
      >
        <Grid item sm={6} xs={6} md={6}>
          <Typography color={"textPrimary"} variant={"h3"}>
            <b>Impression Share</b>
          </Typography>
        </Grid>
        {isLoading ? (
          <IsLoading classes={classes} />
        ) : (
          <Fragment>
            {_.isEmpty(data) || (data && data.data.length == 0) ? (
              <Grid item md={12}>
                <Typography
                  align={"center"}
                  color={"textPrimary"}
                  variant={"body1"}
                >
                  No data to display
                </Typography>
              </Grid>
            ) : (
              <Fragment>
                <Grid item sm={6} xs={6} md={6}>
                  <Typography align={"right"}>
                    <span
                      className={classes.icons}
                      onClick={() => handleReportSent("impShare")}
                    >
                      {icons.plane}
                    </span>
                    &nbsp; &nbsp; &nbsp;
                    <span
                      className={classes.icons}
                      onClick={(event) =>
                        handleDownloadReport("impressionShare", event)
                      }
                    >
                      {icons.download}
                    </span>
                  </Typography>
                </Grid>
                <br />
                <br />
                <Grid item xs={12} sm={12} md={12}>
                  <Card className={classes.card}>
                    <ResponsiveContainer width="100%" height={401}>
                      <ComposedChart
                        data={data.data}
                        ref={(ref) => ref}
                        margin={graphSpacing}
                      >
                        <CartesianGrid strokeDasharray="0 0" vertical={false} />
                        <XAxis
                          dataKey="dateRange"
                          tick={{ fontSize: yAxisFontSize }}
                        />
                        <YAxis
                          axisLine={false}
                          tickFormatter={yAxisFormatter}
                          tick={{ fontSize: yAxisFontSize }}
                        />
                        <Tooltip
                          // labelFormatter={(value) =>
                          //   CommaFormattedNumber(value)
                          // }
                        />
                        <Bar
                          dataKey="searchIS"
                          stackId="a"
                          name="Search Impression Share"
                          fill="#1098F7"
                        />
                        <Bar
                          dataKey="searchLostBudgetIS"
                          stackId="a"
                          name="Search Lost Impression Share (Budget)"
                          fill="#CF0505"
                        />
                        <Bar
                          dataKey="searchLostRankIS"
                          stackId="a"
                          name="Search Lost Impression Share (Rank)"
                          fill="#FE9B3A"
                        />
                      </ComposedChart>
                    </ResponsiveContainer>
                  </Card>
                </Grid>
              </Fragment>
            )}
          </Fragment>
        )}
      </Grid>
    </Paper>
  );
}

export default withStyles(CommonStyles, { withTheme: true })(ImpressionGraph);
